import { render, staticRenderFns } from "./ItemHiraganaChange.html?vue&type=template&id=27cbe502&external"
import script from "./ItemHiraganaChange.ts?vue&type=script&lang=ts&external"
export * from "./ItemHiraganaChange.ts?vue&type=script&lang=ts&external"
import style0 from "./ItemHiraganaChange.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports